<template>
  <div class="app_recycle_cla">
    <div class="black_panel_cla">
      <el-table
        ref="table"
        :data="recycleList"
        style="width: 100%"
        :highlight-current-row="true"
      >
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column
          prop="name"
          :label="this.$t('developer.name')"
        ></el-table-column>
        <el-table-column
          prop="appKey"
          :label="this.$t('developer.appKey')"
        ></el-table-column>

        <el-table-column :label="this.$t('common.action')">
          <template slot-scope="scope">
            <el-button
              class="btn-text-cla"
              type="text"
              @click.stop="withdrawTheApp(scope.row)"
              >{{ $t('developer.withdrawApp') }}</el-button
            >
            <el-button
              class="btn-text-cla"
              type="text"
              @click.stop="destroyTheApp(scope.row)"
              >{{ $t('developer.destroyApp') }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      :title="this.$t('developer.destroyApp')"
      :visible.sync="destory"
      @close="cancleDelete"
      width="40%"
    >
      <label>{{ $t('developer.destroySure') }}</label>
      <el-form
        :model="destroyForm"
        label-width="140px"
        :rules="rule"
        ref="destoryed"
      >
        <el-row :gutter="10" style="margin-top:10px">
          <template v-if="isEmail">
            <el-col :span="16">
              <el-form-item :label="this.$t('center.email')">
                <el-input v-model="email" placeholder="" :disabled="true">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-button
                type="primary"
                @click="changeWay"
                :disabled="!isChange"
                >{{ $t('developer.changeWay') }}</el-button
              >
            </el-col>
          </template>
          <template v-else>
            <el-col :span="16">
              <el-form-item :label="$t('developer.phone')">
                <el-input v-model="phone" placeholder="" :disabled="true">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-button
                type="primary"
                @click="changeWay"
                :disabled="!isChange"
                >{{ $t('developer.changeWay') }}</el-button
              >
            </el-col>
          </template>
          <el-col :span="16">
            <el-form-item :label="this.$t('center.code')" prop="code">
              <el-input v-model.trim="destroyForm.code" placeholder> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <timing
              ref="timing"
              @toGetCode="getEmailCode"
              :status="true"
              :isShow="true"
            >
            </timing>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.stop="cancleDelete">
          {{ $t('common.cancel') }}
        </el-button>
        <el-button
          type="primary"
          @click.stop="submitDelete"
          :disabled="destroyForm.code === ''"
          >{{ $t('common.confirm') }}</el-button
        >
      </div>
    </el-dialog>

    <!-- 撤回 -->
    <el-dialog
      :title="this.$t('developer.withdrawApp')"
      :visible.sync="withDraw"
      @close="withDraw = false"
      width="45%"
    >
      <label>{{ $t('developer.WithdrawSure') }}</label>
      <div slot="footer" class="dialog-footer">
        <el-button @click.stop="withDraw = false">
          {{ $t('common.cancel') }}
        </el-button>
        <el-button type="primary" @click.stop="submitWithDraw">
          {{ $t('common.yes') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  recycleList,
  withdrawApp,
  destroyApp,
  sendVerifyCode,
  checkVrificationCode
} from '@/services/appManagerApi.js'
import timing from '@/components/timing'

export default {
  components: {
    timing
  },
  data() {
    let checkCode = (rule, value, callback) => {
      // 校验验证码是  手机还是邮箱
      if (value) {
        let params = {
          id: this.row.id,
          code: value
        }
        if (this.isEmail) {
          params.deviceType = '1' // 邮箱
        } else {
          params.deviceType = '2' // 手机
        }
        checkVrificationCode(params)
          .then(data => {
            if (data.code === '00000000') {
              return callback()
            } else {
              return callback(new Error(data.message))
            }
          })
          .catch(e => this.errorMessage())
      }
    }
    return {
      recycleList: [],
      destory: false,
      row: [],
      withDraw: false,
      destroyForm: {
        email: '',
        code: '',
        phone: ''
      },
      rule: {
        code: this.validatorInputEmptyRule(true, 6, checkCode)
      },
      email: '',
      phone: '',
      isEmail: false,
      isChange: false
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    // 获取邮箱验证码，定时60s后再次获取
    changeWay() {
      this.isEmail = !this.isEmail
    },
    getEmailCode() {
      let params = {
        id: this.row.id
      }
      params.deviceType = this.isEmail ? '1' : '2' // 1 邮箱  2手机
      sendVerifyCode(params).then(data => {
        if (data.code === '00000000') {
          this.successMessage()
          this.$refs.timing.beginTime()
        } else if (data.code === 'E0010351') {
          this.$message.warning(data.message)
        } else {
          this.errorMessage(data.message)
        }
      })
    },

    submitWithDraw() {
      let params = {
        id: this.row.id
      }
      withdrawApp(params)
        .then(data => {
          if (data.code === '00000000') {
            this.withDraw = false
            this.successMessage(this.$t('developer.withdrawAppSuccess'))
            this.query()
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => {})
    },

    // 销毁
    submitDelete() {
      this.$refs.destoryed.validate(valid => {
        if (valid) {
          let params = {
            appKey: this.row.appKey
          }
          destroyApp(params)
            .then(data => {
              if (data.code === '00000000') {
                this.$message.success(this.$t('developer.destroyAppSuccess'))
                this.destory = false
                this.query()
              } else {
                this.$message.error(data.message)
              }
            })
            .catch(e => {})
        }
      })
    },
    cancleDelete() {
      this.destory = false
      this.destroyForm.email = ''
      this.destroyForm.code = ''
      if (this.$refs.destoryed) {
        this.$refs.destoryed.resetFields()
      }
    },

    destroyTheApp(row) {
      this.destory = true
      this.row = row
      this.destroyForm.email = row.mail
      this.email = this.emailFormat(row.mail)
      this.phone = this.phoneFormat(row.phone)
      if (this.phone && this.email) {
        this.isEmail = false
        this.isChange = true
        return
      }
      if (this.phone && !this.email) {
        this.isEmail = false
        this.isChange = false
        return false
      }
      if (!this.phone && this.email) {
        this.isEmail = true
        this.isChange = false
        return false
      }
    },

    withdrawTheApp(row) {
      this.withDraw = true
      this.row = row
    },
    query() {
      recycleList()
        .then(data => {
          if (data.code === '00000000') {
            this.recycleList = data.payload.results.dbsAppInfoList
            let len = this.recycleList.length
            if (len > 0) {
              let item = this.recycleList[0]
              this.$emit('selectRow', item)
              this.$refs.table.setCurrentRow(item)
            }
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => this.errorMessage())
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/developer/appRecycle.vue